var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "p",
    { staticClass: "margin-bottom-2xl" },
    [
      _c("font-awesome-icon", {
        staticClass: "margin-right-4xs",
        staticStyle: { color: "var(--fa-red)" },
        attrs: { icon: _vm.$v6.solid.faHeart, size: "lg" },
      }),
      _vm._v("\n  Sponsored by\n  "),
      _vm.sponsorUrl
        ? _c(
            "a",
            {
              staticStyle: { "--link-color": "initial" },
              attrs: {
                href: `${_vm.sponsorUrl}`,
                target: "_blank",
                rel: "nofollow",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.sponsorName))]
          )
        : [_vm._v(_vm._s(_vm.sponsorName))],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }